import React, { useEffect, useState } from 'react';
import { Building2, Users, Server, Activity } from 'lucide-react';
import { useAuth } from '../auth/KeycloakContext';

interface DashboardStats {
  total_tenants: number;
  active_tenants: number;
  total_users: number;
  total_mumble_servers: number;
  active_mumble_servers: number;
}

export default function Dashboard() {
  const { keycloak } = useAuth();
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (keycloak?.token) {
      fetch('/api/dashboard/stats', {
        headers: { 'Authorization': `Bearer ${keycloak.token}` }
      })
        .then((res) => res.json())
        .then((data) => {
          setStats(data);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }
  }, [keycloak?.token]);

  if (loading) {
    return <div className="text-slate-500">Laden...</div>;
  }

  const cards = [
    {
      label: 'Einrichtungen',
      value: stats?.total_tenants ?? 0,
      subValue: `${stats?.active_tenants ?? 0} aktiv`,
      icon: Building2,
      color: 'bg-blue-500',
    },
    {
      label: 'Benutzer',
      value: stats?.total_users ?? 0,
      subValue: 'gesamt',
      icon: Users,
      color: 'bg-green-500',
    },
    {
      label: 'Mumble Server',
      value: stats?.total_mumble_servers ?? 0,
      subValue: `${stats?.active_mumble_servers ?? 0} aktiv`,
      icon: Server,
      color: 'bg-purple-500',
    },
    {
      label: 'System Status',
      value: 'Online',
      subValue: 'Alle Dienste',
      icon: Activity,
      color: 'bg-emerald-500',
    },
  ];

  return (
    <div>
      <h1 className="text-2xl font-bold text-slate-800 mb-8">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {cards.map((card, index) => (
          <div
            key={index}
            className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm"
          >
            <div className="flex items-center justify-between mb-4">
              <div className={`p-3 rounded-lg ${card.color}`}>
                <card.icon size={24} className="text-white" />
              </div>
            </div>
            <div className="text-3xl font-bold text-slate-800 mb-1">
              {card.value}
            </div>
            <div className="text-slate-600">{card.label}</div>
            <div className="text-sm text-slate-400 mt-1">{card.subValue}</div>
          </div>
        ))}
      </div>

      {/* Recent Activity */}
      <div className="mt-8">
        <h2 className="text-xl font-semibold text-slate-800 mb-4">
          Letzte Aktivitaeten
        </h2>
        <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm">
          <p className="text-slate-500">Noch keine Aktivitaeten vorhanden.</p>
        </div>
      </div>
    </div>
  );
}
